import { LocalStorageKeys, SessionStorageKeys } from "utils/storageKeys";
import { logError } from "services/logging";
import { queryClient } from "app/global";
import { currentUserQuery } from "services/users";
import { User } from "services/users/model";
export { LocalStorageKeys, SessionStorageKeys } from "utils/storageKeys";

// Keys a new tab never inherits. Each holds a credential that acts for whoever
// presents it, so it stays in the tab that received it.
const TAB_ONLY_KEYS: readonly string[] = [
  SessionStorageKeys.checkout,
  SessionStorageKeys.urlSecrets,
];

// Session storage as a new tab of this browser may inherit it.
export function snapshotSessionStorage() {
  const snapshot: Record<string, string> = {};
  for (let index = 0; index < sessionStorage.length; index++) {
    const key = sessionStorage.key(index);
    const value = key === null ? null : sessionStorage.getItem(key);
    if (key !== null && value !== null && !TAB_ONLY_KEYS.includes(key)) {
      snapshot[key] = value;
    }
  }
  return JSON.stringify(snapshot);
}

export function hydrateSessionStorage() {
  try {
    // When openning a new tab we hydrate session storage.
    // We pass data between tabs via local storage.
    const serializedSessionStorage = localStorage.getItem(
      LocalStorageKeys.sessionStorageSnapshot
    );
    if (!serializedSessionStorage) {
      return;
    }

    const savedState = JSON.parse(serializedSessionStorage) as Record<string, string>;
    for (const [key, value] of Object.entries(savedState)) {
      if (!TAB_ONLY_KEYS.includes(key)) {
        sessionStorage.setItem(key, value);
      }
    }

    localStorage.removeItem(LocalStorageKeys.sessionStorageSnapshot);
  } catch (error) {
    logError("Failed to hydrate session storage from local storage", error);
  }

  const serializedUser = sessionStorage.getItem(SessionStorageKeys.user);
  if (serializedUser) {
    const user = JSON.parse(serializedUser) as User;
    queryClient.setQueryData(currentUserQuery().queryKey, user);
  }
}
